var map = {
	"./icn-banks-g.svg": 567,
	"./icn-banks-old.svg": 1408,
	"./icn-banks.svg": 204,
	"./icn-bf-o.svg": 568,
	"./icn-bf-w.svg": 569,
	"./icn-bf-y.svg": 146,
	"./icn-bf.svg": 147,
	"./icn-consumers-g.svg": 570,
	"./icn-consumers-old.svg": 1409,
	"./icn-consumers.svg": 128,
	"./icn-engagement-shield.svg": 299,
	"./icn-engagement.svg": 1410,
	"./icn-oil-green-active.svg": 1411,
	"./icn-oil-green-inactive.svg": 1412,
	"./icn-oil-orange-active.svg": 1413,
	"./icn-oil-orange-inactive.svg": 1414,
	"./icn-oil-red-active.svg": 1415,
	"./icn-oil-red-inactive.svg": 1416,
	"./icn-oil-redorange-active.svg": 1417,
	"./icn-oil-redorange-inactive.svg": 1418,
	"./icn-oil-yellow-active.svg": 1419,
	"./icn-oil-yellow-inactive.svg": 1420,
	"./icn-po-o.svg": 571,
	"./icn-po-w.svg": 572,
	"./icn-po-y.svg": 148,
	"./icn-po.svg": 149,
	"./icn-pp-o.svg": 573,
	"./icn-pp-w.svg": 574,
	"./icn-pp-y.svg": 150,
	"./icn-pp.svg": 151,
	"./icn-producers-g.svg": 575,
	"./icn-producers-old.svg": 1421,
	"./icn-producers.svg": 129,
	"./icn-rb-o.svg": 576,
	"./icn-rb-w.svg": 577,
	"./icn-rb-y.svg": 152,
	"./icn-rb.svg": 153,
	"./icn-socially-responsible.svg": 1422,
	"./icn-sy-o.svg": 578,
	"./icn-sy-w.svg": 579,
	"./icn-sy-y.svg": 154,
	"./icn-sy.svg": 155,
	"./icn-tb-o.svg": 580,
	"./icn-tb-w.svg": 581,
	"./icn-tb-y.svg": 156,
	"./icn-tb.svg": 157
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1782;



//////////////////
// WEBPACK FOOTER
// ./static/images ^\.\/icn\-.*\.svg$
// module id = 1782
// module chunks = 0